import { toLower } from 'lodash';

export const nameToUrl = name =>
    toLower(name)
        .replace(/[^\w\d\s-]/g, '')
        .replace(/\s+/g, '-');

export const nameToBannerUrl = name =>
    toLower(name)
        .replace(/\.|\s|'/g, '');

export const buildProfileUrl = (id, name, type) =>
    `/profile/${type}/${id}/${nameToUrl(name)}`;



// WEBPACK FOOTER //
// ./src/js/utils/url.js